import { useEffect } from 'react'
import { setEmptyComponentStatus } from 'src/store/Reducer/page/explorerPageSlice'
import { RootState } from 'src/store/store'
import { SvgType } from 'src/types/types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import ExplorerMainTemplate from 'src/components/atomic/template/Service/ExplorerMain'
import useExplorerMainEventBus from 'src/hooks/useEventBus/useExplorerMainEventBus'
import { COLOR } from 'src/constants/colors'

export type ExplorerDataPropsType = {
  ExplorerFileItems: ExplorerFileItemType[]
  ExplorerStorageItems: ExplorerStorageItemType[]
}

type ExplorerFileItemType = {
  name: string
  svg_name: SvgType
  bgColor: string
  onClick: () => void
  className: string
}
type ExplorerStorageItemType = {
  name: string
  size: string
  onClick: () => void
  onClickDisabled: boolean
  className: string
}

const ExplorerMain = () => {
  const { t } = useTranslation()
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const deviceAuth = useAppSelector((state: RootState) => state.deviceAuth)
  const { InternalInfo, ExternalInfo } = useAppSelector((state: RootState) => state.storageInfo)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const ExplorerFileItems: ExplorerFileItemType[] = [
    {
      name: t('EXPLORER.CATEGORY.IMAGE', { defaultValue: 'Images' }),
      svg_name: 'explorer_image_icon',
      bgColor: COLOR.brand2,
      onClick: () => {
        navigate('/explorer/detail/Images', {
          state: { Title: t('EXPLORER.CATEGORY.IMAGE'), Type: 0 },
        })
      },
      className: 'explorer_images',
    },
    {
      name: t('EXPLORER.CATEGORY.VIDEO', { defaultValue: 'Videos' }),
      svg_name: 'explorer_video_icon',
      bgColor: '#FACFCF',
      onClick: () => {
        navigate('/explorer/detail/Videos', {
          state: { Title: t('EXPLORER.CATEGORY.VIDEO'), Type: 1 },
        })
      },
      className: 'explorer_videos',
    },
    {
      name: t('EXPLORER.CATEGORY.AUDIO', { defaultValue: 'Audios' }),
      svg_name: 'explorer_audios_icon',
      bgColor: '#F6E3BC',
      onClick: () => {
        navigate('/explorer/detail/Audios', {
          state: { Title: t('EXPLORER.CATEGORY.AUDIO'), Type: 2 },
        })
      },
      className: 'explorer_audios',
    },
    {
      name: t('EXPLORER.CATEGORY.DOCUMENT', { defaultValue: 'Documents' }),
      svg_name: 'explorer_document_icon',
      bgColor: '#D9BCF6',
      onClick: () => {
        navigate('/explorer/detail/Documents', {
          state: { Title: t('EXPLORER.CATEGORY.DOCUMENT'), Type: 3 },
        })
      },
      className: 'explorer_documents',
    },
    {
      name: t('EXPLORER.CATEGORY.DOWNLOAD', { defaultValue: 'Downloads' }),
      svg_name: 'explorer_down_icon',
      bgColor: '#CFF0FA',
      onClick: () => {
        navigate('/explorer/detail/Downloads', {
          state: { Title: t('EXPLORER.CATEGORY.DOWNLOAD') },
        })
      },
      className: 'explorer_downloads',
    },
    {
      name: t('EXPLORER.CATEGORY.APK', { defaultValue: 'APK' }),
      svg_name: 'explorer_apk_icon',
      bgColor: COLOR.black6,
      onClick: () =>
        navigate('/explorer/detail/APK', { state: { Title: t('EXPLORER.CATEGORY.APK'), Type: 4 } }),
      className: 'explorer_apk',
    },
  ]

  const ExplorerStorageItems = [
    {
      name: t('EXPLORER.STORAGE.INTERNAL', { defaultValue: 'Internal storage' }),
      size:
        InternalInfo.Now === 0 || !InternalInfo.Now
          ? `${t('EXPLORER.STORAGE.ERROR_DATA', { defaultValue: 'Not Found' })}`
          : `${InternalInfo.Now}GB / ${InternalInfo.Max}GB`,
      onClick: () => {
        InternalInfo.Now !== 0 &&
          navigate('/explorer/detail/INTERNAL', {
            state: { Title: t('EXPLORER.STORAGE.INTERNAL') },
          })
      },
      onClickDisabled: InternalInfo.Now === 0,
      className: 'explorer_internal_strage',
    },
    {
      name: t('EXPLORER.STORAGE.EXTERNAL', { defaultValue: 'External' }),
      size: !ExternalInfo.Exist
        ? `${t('EXPLORER.STORAGE.ERROR_DATA', { defaultValue: 'Not Found' })}`
        : `${ExternalInfo.Now}GB / ${ExternalInfo.Max}GB`,
      onClick: () => {
        ExternalInfo.Now !== 0 &&
          navigate('/explorer/detail/EXTERNAL', {
            state: { Title: t('EXPLORER.STORAGE.EXTERNAL') },
          })
      },
      onClickDisabled: ExternalInfo.Now === 0,
      className: 'explorer_external_strage',
    },
  ]

  useEffect(() => {
    switch (true) {
      case !Connection:
        dispatch(setEmptyComponentStatus('ExplorerOffline'))
        break
      case !deviceAuth.File:
        dispatch(setEmptyComponentStatus('ExplorerNoAuth'))
        break
      default:
        dispatch(setEmptyComponentStatus('default'))
        break
    }
  }, [Connection, deviceAuth.File, dispatch])

  useExplorerMainEventBus()

  const data: ExplorerDataPropsType = {
    ExplorerFileItems,
    ExplorerStorageItems,
  }

  return <ExplorerMainTemplate data={data} />
}
export default ExplorerMain
